import { Author as Authors } from '@/types/summary'
import { AuthorType, getAuthorLabel } from '../../util'
import { LabelKey, LabelValues } from '.'

interface Props {
  authors: Authors[]
  authorType?: AuthorType
  showBorder?: boolean
}
export const Author: React.FC<Props> = ({
  authors,
  authorType = 1,
  showBorder,
}) => {
  return (
    <div className="sm:flex sm:pb-[6px] sm:w-full text-sm sm:text-base">
      <LabelKey text={getAuthorLabel(authorType)} />
      <LabelValues type="author" values={authors} showBorder={showBorder} />
    </div>
  )
}
